import React from 'react';
import PropTypes from 'prop-types';

function IconMore({ size = 10, color = `white` }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.0001 13C12.5523 13 13.0001 12.5523 13.0001 12C13.0001 11.4477 12.5523 11 12.0001 11C11.4478 11 11.0001 11.4477 11.0001 12C11.0001 12.5523 11.4478 13 12.0001 13Z" fill={color} stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" fill={color} stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.99994 13C5.55222 13 5.99994 12.5523 5.99994 12C5.99994 11.4477 5.55222 11 4.99994 11C4.44765 11 3.99994 11.4477 3.99994 12C3.99994 12.5523 4.44765 13 4.99994 13Z" fill={color} stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconMore.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string
}

export default IconMore;
